import {Container} from "./Container"

export const NotFoundStyles = {
    Container: Container
}